import React, { Component } from 'react';
import { withRouter, Redirect } from 'react-router-dom';
import { withTranslation, useTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet';

import { getBaseName } from '../Utils';
import { replacedoamin } from '../Utils';
import topicList from '../data/topics.json';
import '../form-grid.css';


class SubscribeForm extends Component {

    state = {
        hash: null,
        email: "",
        disableEmail: true,
        topics: topicList
    }

    componentDidMount() {
        this.handleHashParam();
    }

    async handleHashParam() {
        const urlParams = new URLSearchParams(this.props.location.search);
        const hash = urlParams.get("hash");
        if (hash === null) {
            this.setState({disableEmail: false});
        } else {
            const apiParams = new URLSearchParams({
                hash: hash
            });
            const apiUrl = `${getBaseName()}/api/check?${apiParams}`;
            try {
                const response = await fetch(apiUrl,{
                    method: "GET"
                });

                const result = await response.json();
                
                const state = this.state;

                state.hash = result.hash;
                state.email = result.email;
                state.disableEmail = true;
                result.subscribed.map((key) => {
                    state.topics[key].checked = true;
                });

                this.setState(state);

            } catch (error) {
                this.setState({disableEmail: false});
            }
        }
    }
    
    handleTopicChange(e) {
        const chkbox = e.target;

        const topics = this.state.topics;
        topics[chkbox.id].checked = chkbox.checked;
        
        this.setState({"topics":topics});
    }

    handleEmailChange(e) {
        this.setState({
            email:e.target.value
        });
    }

    async handleSubmitForm(e) {
        e.preventDefault();

        const { i18n, history } = this.props;

        if (window.grecaptcha === undefined) {
            //greacaptcha cannot be loaded
            //console.log('grecaptcha is not ready!');
        } else {            
            const recaptchaSiteKey = process.env['REACT_APP_RECAPTCHA_SITE_KEY'];
            const recaptchaToken = await window.grecaptcha.execute(recaptchaSiteKey,{action:'subscription_form'});

            //console.log(recaptchaToken);

            const apiUrl = `${getBaseName()}/api/subscribe`;
    
            const requestBody = {
                hash: this.state.hash,
                email: this.state.email,
                subscribed: [],
                recaptchaToken: recaptchaToken
            };

            Object.keys(this.state.topics).map((key) => {
                const topic = this.state.topics[key];
                if (topic.checked) {
                    requestBody.subscribed.push(key);
                }
            });

            try {
                const response = await fetch(apiUrl,{
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(requestBody)
                });

                //console.log(response);

                if (response.status === 200) {
                    const result = await response.json();

                    console.log(result);

                    history.push(`/campaignFormDo.jsp?lang=${i18n.language}`,{ subscribeResult : result.subscribeResult});
                } else {
                    
                }
            } catch (error) {
                //console.log(error);
            }
        }
    }

    handleResetForm(e) {
        e.preventDefault();

        const urlParams = new URLSearchParams(this.props.location.search);
        const hash = urlParams.get("hash");
        if (hash === null) {
            this.setState((state,props) => {
                let newState = Object.assign({},state,{email:""});
                Object.keys(newState.topics).map((key) => {
                    const topic = newState.topics[key];
                    topic.checked = false;
                });
                return newState;
            });
        }
    }

    render() {
        const { i18n, t } = this.props;

        const sectionId = '29,1096';
        const pageId = '29,1096';

        const recaptchaSiteKey = process.env['REACT_APP_RECAPTCHA_SITE_KEY'];

        const SFC_DOMAIN = `${process.env['REACT_APP_SFC_DOMAIN']}`;
        const SFCSC_DOMAIN = `${process.env['REACT_APP_SFCSC_DOMAIN']}`;

        const REACT_APP_APPS_DOMAIN = `${process.env['REACT_APP_APPS_DOMAIN']}`;

        const ga4ScriptId = `${process.env['REACT_APP_GA4_ID']}`;

        let gaScript = `
            var _gaq = _gaq || []; 
            _gaq.push(['_setAccount', '${process.env['REACT_APP_GA_ID']}']); 
            _gaq.push(['_setDomainName', '${REACT_APP_APPS_DOMAIN}']); 
            _gaq.push(['_trackPageview']); 
            
            (function () { 
            var ga = document.createElement('script'); ga.type = 'text/javascript'; ga.async = true; 
            ga.src = ('https:' == document.location.protocol ? 'https://ssl' : 'http://www') + '.google-analytics.com/ga.js'; 
            var s = document.getElementsByTagName('script')[0]; s.parentNode.insertBefore(ga, s); 
            })();
        `;

        
        let ga4Script = `
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
        
            gtag('config', '${process.env['REACT_APP_GA4_ID']}');      
        `;

        let lang = 'en';
        let googleLang = "en-US";
        if (i18n.language === 'TC') {
            lang = 'zh-hant';
            if (window.location.hostname === SFCSC_DOMAIN) {
                googleLang = "zh-CN";
            } else {                
                googleLang = "zh-HK";
            }
        }

        window.jsMenu = {
            header: 'header',
            footer: 'footer',
            sidebar: 'sidebar',
            content: 'content',
            sectionId: sectionId,
            pageId: pageId,
            lang: lang,
            useCSS: true,
            overrideTopUrl: {
                en: `//${process.env['REACT_APP_APPS_DOMAIN']+process.env['PUBLIC_URL']}/campaignForm.jsp?lang=EN`,
                zhHant: `//${process.env['REACT_APP_APPS_DOMAIN']+process.env['PUBLIC_URL']}/campaignForm.jsp?lang=TC`,
                zhHans: `//${process.env['REACT_APP_SFCSC_DOMAIN']}/TuniS/${process.env['REACT_APP_APPS_DOMAIN']+process.env['PUBLIC_URL']}/campaignForm.jsp?lang=TC`
            }	
        };
    
        let menujs;
        if (window.location.hostname === SFCSC_DOMAIN) {
            menujs = `//${SFCSC_DOMAIN}/TuniS/${SFC_DOMAIN}/web/js-menu/menu.js`;
        } else {
            menujs = `//${SFC_DOMAIN}/web/js-menu/menu.js`;
        }
    
        return (
            <React.Fragment>
                <Helmet>
                    <title>{t('form.title')}</title>
                    <script type="text/javascript" src={`//www.google.com/recaptcha/api.js?render=${recaptchaSiteKey}&hl=${googleLang}`}></script>
                    <script type="text/javascript" src={menujs}></script>
                    <script>{gaScript}</script>
                    <script async src={`https://www.googletagmanager.com/gtag/js?id=${ga4ScriptId}`}></script>
                    <script>{ga4Script}</script>
                </Helmet>
                <div className="headline">
                    {t('form.title')}
                </div>
                <p>
                    {t('form.content.text1')}
                    <a href={replacedoamin(t('form.content.link1'))}>{t('form.policy-link-label')}</a>
                    
                    {t('form.content.text2')}
                </p>
                <p>{t('form.content.text3')}</p>
                <p>{t('form.content.text4')}</p>

                <div className="campaign-form">
                    <form>
                        <div className="campaign-form-row">
                            <div className="campaign-form__col">
                                <div className="field-title">{t("form.groups.g1.header")}</div>
                                {["t01","t02","t03","t04"].map((key) =>
                                    <Topic key={key} id={key} 
                                        value={topicList[key].name}
                                        checked={this.state.topics[key].checked}
                                        handleTopicChange={this.handleTopicChange.bind(this)}/>
                                )}
                            </div>
                            <div className="campaign-form__col">
                                <div className="field-title">{t("form.groups.g2.header")}</div>
                                {["t05","t06","t07","t08","t09","t10","t11"].map((key) =>
                                    <Topic key={key} id={key} 
                                        value={topicList[key].name}
                                        checked={this.state.topics[key].checked}
                                        handleTopicChange={this.handleTopicChange.bind(this)}/>
                                )}
                            </div>
                            <div className="campaign-form__col campaign-form__col--wide">
                                <div className="field-title">{t("form.groups.g3.header")}</div>
                                <div className="campaign-form__sub-col">
                                    {["t12","t13","t14","t15","t16","t23"].map((key) =>
                                        <Topic key={key} id={key} 
                                            value={topicList[key].name}
                                            checked={this.state.topics[key].checked}
                                            handleTopicChange={this.handleTopicChange.bind(this)}/>
                                    )}
                                </div>
                                <div className="campaign-form__sub-col">
                                    {["t17","t24","t18","t25","t22","t19","t20","t21"].map((key) =>
                                        <Topic key={key} id={key} 
                                            value={topicList[key].name}
                                            checked={this.state.topics[key].checked}
                                            handleTopicChange={this.handleTopicChange.bind(this)}/>
                                    )}
                                </div>
                            </div>
                        </div>
                        <div className="form-row">
                            <div className="field-holder">
                                <div className="field-title">{t('form.labels.email-textbox')}</div>
                                <div className="field-body">
                                    <label className="visuallyhidden" htmlFor="campaign-email-address">
                                        <span style={{display:"none"}}>{t('form.labels.email-textbox')}</span>
                                    </label>
                                    <input 
                                        type="email" 
                                        id="campaign-email-address" 
                                        name="campaign-email-address"
                                        value={this.state.email}
                                        disabled={this.state.disableEmail}
                                        onChange={this.handleEmailChange.bind(this)}/>
                                </div>
                            </div>
                        </div>
                        <div className="form-row">
                            <div className="field-holder">
                                <button 
                                    className="form-submit btn btn-primary"
                                    onClick={this.handleSubmitForm.bind(this)}>
                                    {t('form.labels.submit-button')}
                                </button>&nbsp;
                                <button 
                                    className="form-reset btn btn-primary btn-invert"
                                    onClick={this.handleResetForm.bind(this)}>
                                    {t('form.labels.reset-button')}
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </React.Fragment>                
        );
    }
}

export default withRouter(withTranslation()(SubscribeForm));

function Topic(props) {
    const { t } = useTranslation();
    return (
        <label>
            <input type="checkbox"
                id={props.id} 
                name={props.id}
                value={props.value}
                onChange={props.handleTopicChange}
                checked={props.checked}/>
            <span>{t(`form.topics.${props.id}.label`)}</span>
        </label>
    );
}